module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legend-section"
  }, [_c('v-expansion-panels', {
    attrs: {
      "dark": "",
      "accordion": ""
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('h2', {
    staticClass: "legend-top-title"
  }, [_vm._v("Legend")])]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "legend-right-section",
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('h3', {
    staticClass: "side-title"
  }, [_vm._v(_vm._s(_vm.rightTitle))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('div', [_c('v-simple-table', {
    staticClass: "legend-table",
    attrs: {
      "dark": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('tbody', _vm._l((_vm.rightSections), function(item) {
          return _c('tr', {
            key: item.title
          }, [_c('td', [_c('h3', {
            staticClass: "title mt-3 mb-0"
          }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
            staticClass: "caption"
          }, [_vm._v(_vm._s(item.description))])])])
        }), 0)]
      },
      proxy: true
    }])
  })], 1)])], 1)], 1)], 1), _vm._v(" "), (_vm.showleftSideIcon) ? _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('v-img', {
    staticClass: "float-left mt-2",
    attrs: {
      "src": "/static/img/instagram.png",
      "width": "64px"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('v-img', {
    staticClass: "float-right",
    attrs: {
      "src": "/static/img/kobe_white.png",
      "width": "72px"
    }
  })], 1)], 1) : _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-img', {
    staticClass: "float-right",
    attrs: {
      "src": "/static/img/kobe_white.png",
      "width": "72px"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9ffb36c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/Legend.vue
// module id = 2253
// module chunks = 0